export function generateBulkVCard(
  contacts: { name: string; phone: string; email?: string; tournament?: string; category?: string }[]
) {
  return contacts
    .map(
      (c) => `
BEGIN:VCARD
VERSION:3.0
FN:${c.name}
N:${c.name};;;;;
TEL;TYPE=cell:${c.phone}
${c.email ? `EMAIL:${c.email}` : ""}
${c.tournament && c.category ? `ORG:${c.tournament} (${c.category})` : ""}
END:VCARD
`
    )
    .join("\n");
}
